<template>
  <div class="approval-wait-approval">
    <div class="search-hd">
      <el-form
        :inline="true"
        @submit.native.prevent
      >
        <!-- 搜索项 -->
        <el-form-item style="float: right">
          <search-input
            v-model="formSearch.keyword"
            :placeholder="$t('crm_approval_wait_approval.btcjr')"
            @fetch="onPageChange({ page: 1 })"
          ></search-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-bd">
      <custom-table
        ref="customTb1"
        height="100%"
        :data="tableList"
        :column="tableColumn"
        :index="true"
        @filter="filterChange"
        @sort="sortChange"
        :slots="['workflowName']"
      >
        <template v-slot:workflowName="scope">
          <span
            v-if="funcView.my_approval_approval"
            class="workflow-name"
            @click="onApproval(scope.row)"
          >{{scope.row.workflowName}}</span>
          <span v-else>{{funcView.workflowName}}</span>
        </template>
        <el-table-column :label="$t('Common.com_handle')">
          <template slot-scope="scope">
            <span></span>
            <el-button
              v-if="funcView.my_approval_approval"
              type="text"
              size="mini"
              @click="onApproval(scope.row)"
            >{{funcView.my_approval_approval}}</el-button>
          </template>
        </el-table-column>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page
        :total="totalRows"
        :page="formSearch.pageNum"
        :size="formSearch.pageSize"
        @change="onPageChange"
      ></custom-page>
    </div>
  </div>
</template>

<script>
/** 待我审批 */
import apis from '@/utils/apis';
import languageInjectMixins from '@/mixins/language_inject_mixins';
// import approveAuthBtn from './approve_auth_btn';
import tableFilterValueGetParamMixins from '@/mixins/table_filterValue_getParam_mixins.js';

export default {
  mixins: [languageInjectMixins, tableFilterValueGetParamMixins],
  components: {},
  data() {
    return {
      tableCode: 'examine_approval_wait_approval',
      formSearch: {
        workflowClass: null,
        keyword: '',
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1,
      },
      tableList: [],
      totalRows: 0,
      // 详情是否有更新记录
      updateRecord: [],
    };
  },
  props: {
    workflowClass: {
      type: Number,
    },
  },
  methods: {
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    getTableList() {
      this.$getJSON(apis.apsApprovePageWaitApprove, this.formSearch).then((res) => {
        this.tableList = res.data.records;
        this.totalRows = res.data.total;
      });
    },
    onApproval(row) {
      if (['leasing_contract', 'lease_renewal_contract', 'frame_contract', 'frame_order', 'trail_order', 'lease_sales_order'].includes(row.workflowType)) {
        this.jump('/contractdetail', { contractId: row.bizId, approveType: row.workflowType, parentPath: this.$route.path });
        return;
      }
      this.jump('/examine/approvalDetail', {
        workflowType: row.workflowType,
        bizId: row.bizId,
      });
    },
    onUpdate() {
      this.updateRecord.push(1);
    },
  },
  mounted() {
    this.formSearch.workflowClass = this.workflowClass || null;
    this.getTableColumn();
    this.getTableList();
    this.Bus.$on('/examine/approvalDetail:update', this.onUpdate);
  },
  activated() {
    if (this.updateRecord.length) {
      this.updateRecord = [];
      this.getTableList();
    }
  },
};
</script>

<style lang="scss">
.approval-wait-approval {
  display: flex;
  flex-direction: column;
  height: 100%;

  .workflow-name {
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>
